import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getBedroomsOffer({
  payload: { options }
}: ReturnType<typeof Actions.getBedroomsOffer>) {
  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/agency/partners/hotel/${
        options.agency_partner_id
      }/offers?partner_hotel_room_id=${
        options.partner_hotel_room_id
      }&page_size=5&page=${options.page || 1}`
    )

    if (response.ok) {
      const { agency_partner_hotel_offers } = response.data
      yield put(
        Actions.getBedroomsOfferSuccess({ agency_partner_hotel_offers })
      )
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getBedroomsOfferFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getBedroomsOfferFailure(message))
  }
}

export function* sendBedroomsOffer({
  payload: { agency_partner_hotel_offers }
}: ReturnType<typeof Actions.sendBedroomsOffer>) {
  try {
    const responsePayload = { agency_partner_hotel_offers }
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/agency/partners/hotel/${agency_partner_hotel_offers[0].agency_partner_id}/offers`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendBedroomsOfferSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendBedroomsOfferFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendBedroomsOfferFailure(message))
  }
}
